import { Calendar as CalIcon } from "lucide-react";

const toISO = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// Native date input with reliable, timezone-safe min/max range enforcement.
// value and onChange use the "YYYY-MM-DD" string format.
export const DatePicker = ({ value, onChange, testid, minDate, maxDate }) => {
  const min = minDate ? toISO(minDate) : undefined;
  const max = maxDate ? toISO(maxDate) : undefined;

  return (
    <div className="relative mt-1.5">
      <CalIcon className="w-4 h-4 text-[var(--gold)] absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
      <input
        type="date"
        data-testid={testid}
        value={value || ""}
        min={min}
        max={max}
        onChange={(e) => onChange(e.target.value)}
        className="w-full min-w-0 h-10 rounded-md border border-[var(--border)] bg-[var(--card)] pl-9 pr-3 text-sm text-[var(--text-primary)] hover:border-[var(--border-gold)] focus:outline-none focus:border-[var(--border-gold)] transition-colors"
      />
    </div>
  );
};
